var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M11.857 2.159c.498.328.949.717 1.343 1.155V2.06a.9.9 0 0 1 1.8 0v3.5a1 1 0 0 1-1 1h-3.498a.9.9 0 1 1 0-1.8h1.565a5.198 5.198 0 0 0-9.074 1.838l-.005-.001a.9.9 0 1 1-1.687-.629 7 7 0 0 1 10.556-3.81M1 10a1 1 0 0 1 1-1h3.499a.9.9 0 0 1 0 1.8h-1.88a5.2 5.2 0 0 0 9.388-1.398l.005.001a.9.9 0 1 1 1.687.629A7 7 0 0 1 2.8 12.686v.814a.9.9 0 1 1-1.8 0z"
  })));
};
export { SvgReload as ReactComponent };